export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7387.7c6dfd56.jpg";